import gql from 'graphql-tag';

export const UPDATE_CAMPAIGN = gql`
  mutation UpdateCampaign($input: CampaignsInputUpdate!, $id: String!) {
    updateCampaign(input: $input, id: $id)
  }
`;
